import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/contexts/AppContext";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AdminLayout from "@/components/admin/AdminLayout";
import Customers from "@/pages/admin/Customers";
import Orders from "@/pages/admin/Orders";
import Products from "@/pages/admin/Products";
import Invoice from "@/pages/admin/Invoice";
import Course from "@/pages/Course";
import MyOrders from "@/pages/MyOrders";
import Bookings from "@/pages/admin/Bookings";
import Availability from "@/pages/admin/Availability";

const RequireAdmin = ({ children }) => {
  const { user } = useApp();
  if (!user || user.role !== "admin") return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/courses" element={<Course />} />
          <Route path="/courses/:id" element={<Course />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/my-orders" element={<MyOrders />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminLayout />
              </RequireAdmin>
            }
          >
            <Route index element={<Navigate to="/admin/customers" replace />} />
            <Route path="customers" element={<Customers />} />
            <Route path="orders" element={<Orders />} />
            <Route path="products" element={<Products />} />
            <Route path="bookings" element={<Bookings />} />
            <Route path="availability" element={<Availability />} />
          </Route>
          <Route path="/admin/orders/:id/invoice" element={
            <RequireAdmin>
              <Invoice />
            </RequireAdmin>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AppProvider>
  );
}

export default App;
